import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNpm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNpm"><Path d="M3 21H12V7.5H16.5V21H21V3H3V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNpm;
